import { useIntl } from 'react-intl';

import UFOSegment from '@atlaskit/react-ufo/segment';

import { useLocalizedHref } from '@/libraries/web-framework/src/localization/use-localized-href';
import { LogoV3 } from '@/libraries/wpl/foundations/src/logo-v3';
import { ProductPageSubNav } from '@/patterns/global-nav/src/nav-product-page';

const CompassLogoComponent = () => {
	return <LogoV3 brand="compass" type="logo" appearance="brand" />;
};

export const CompassNav = () => {
	const intl = useIntl();

	const pricingHref = useLocalizedHref('/software/compass/pricing');
	const resourcesHref = useLocalizedHref('/software/compass/resources');
	return (
		<UFOSegment name="confluence-pt-cfind-1234-CompassNav">
			<ProductPageSubNav
				productLogoUrl="/software/compass"
				productLogo={<CompassLogoComponent />}
				productLogoAriaLabel={intl.formatMessage({
					id: 'CompassPageTemplate.navbar.compass-logo',
					defaultMessage: 'Compass logo',
				})}
				mobileLogo={<CompassLogoComponent />}
				productPageNavLinks={[
					{
						globalLinksKey: 'features',
						linkText: intl.formatMessage({
							id: 'CompassPageTemplate.navbar.features',
							defaultMessage: 'Features',
						}),
						hasSubnav: false,
						productKey: 'compass',
						href: useLocalizedHref('/software/compass/features'),
					},
					{
						globalLinksKey: 'pricing',
						linkText: intl.formatMessage({
							id: 'CompassPageTemplate.navbar.pricing',
							defaultMessage: 'Pricing',
						}),
						hasSubnav: false,
						productKey: 'compass',
						href: pricingHref,
					},
					{
						globalLinksKey: 'resources',
						linkText: intl.formatMessage({
							id: 'CompassPageTemplate.navbar.resources',
							defaultMessage: 'Resources',
						}),
						hasSubnav: false,
						productKey: 'compass',
						href: resourcesHref,
					},
				]}
				isShowTryNowLink={false}
				mobileLinksSections={[
					{
						mobileLinkKey: 'mobile-compass',
						mobileLinksProps: [
							{
								globalLinksKey: 'features',
								linkText: intl.formatMessage({
									id: 'CompassPageTemplate.navbar.features',
									defaultMessage: 'Features',
								}),
								hasSubnav: false,
								productKey: 'compass',
								href: useLocalizedHref('/software/compass/features'),
							},
							{
								globalLinksKey: 'pricing',
								linkText: intl.formatMessage({
									id: 'CompassPageTemplate.navbar.pricing',
									defaultMessage: 'Pricing',
								}),
								hasSubnav: false,
								productKey: 'compass',
								href: pricingHref,
							},
							{
								globalLinksKey: 'resources',
								linkText: intl.formatMessage({
									id: 'CompassPageTemplate.navbar.resources',
									defaultMessage: 'Resources',
								}),
								hasSubnav: false,
								productKey: 'compass',
								href: resourcesHref,
							},
						],
					},
				]}
			/>
		</UFOSegment>
	);
};
